import './App.css'
import { Box } from '@veracity/vui'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Templates from './pages/Templates'
import Checklists from './pages/Checklists'
import ChecklistView from './pages/ChecklistView'
import HomePage from './pages/HomePage'
import AppHeader from './components/AppHeader'
import ProtectedRoute from './components/ProtectedRoute'
import NotFound from './pages/NotFound'

function App() {  
    return (
      <>
        <BrowserRouter>
          <AppHeader />
          <Box w="100%" minH="calc(100vh - 80px)" flexDirection="column">
            <Routes>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route 
                path="/templates" 
                element={
                  <ProtectedRoute>
                    <Templates />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/checklists" 
                element={
                  <ProtectedRoute>
                    <Checklists />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/checklist" 
                element={<Navigate to="/checklists" replace />}
              />
              <Route 
                path="/checklist/:checklist_id" 
                element={
                  <ProtectedRoute>
                    <ChecklistView />
                  </ProtectedRoute>
                } 
              />
              <Route path="/home" element={<HomePage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </BrowserRouter>
      </>
    )
  }

export default App
